var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { useState } from 'react';
import * as yup from 'yup';
import { yupResolver } from '@hookform/resolvers/yup';
import Button from '../../../../components/Button';
import FadeIn from '../../../../components/Animation/FadeIn';
import Heading from '../../../../components/Typography/Heading';
import { useValidation } from '../../../../hooks/useValidation';
import { useForm } from 'react-hook-form';
import FormRow from '../../../../components/Form/Row';
import TextInput from '../../../../components/Fields/TextInput';
import { Fields } from '../../../../utils/Fields';
import Paragraph from '../../../../components/Typography/Paragraph';
import axiosInstance from '../../../../config/axios';
import { api } from '../../../../config/api';
import AvatarInput from '../../../../components/Fields/AvatarInput';
import Checkbox from '../../../../components/Fields/Checkbox';
import { serialize } from 'object-to-formdata';
import { useNavigate } from 'react-router-dom';
import { useSignIn } from 'react-auth-kit';
import { RoutePaths } from '../../../../config/routes';
import jwtDecode from 'jwt-decode';
import { usePlaceholder } from '../../../../hooks/usePlaceholder';
import Seo from '../../../../components/Seo';
var VisitorData = function () {
    var navigate = useNavigate();
    var signIn = useSignIn();
    var _a = useState(false), loading = _a[0], setLoading = _a[1];
    var _b = useValidation(), textRequired = _b.textRequired, emailRequired = _b.emailRequired, passwordRequired = _b.passwordRequired, passwordConfirmation = _b.passwordConfirmation, gdprRequired = _b.gdprRequired, avatarRequired = _b.avatarRequired, passwordInstructions = _b.passwordInstructions;
    var placeholders = usePlaceholder();
    var schema = yup.object().shape({
        avatar: avatarRequired,
        last_name: textRequired,
        first_name: textRequired,
        email: emailRequired,
        password: passwordRequired,
        password_confirmation: passwordConfirmation('password'),
        consent_gdpr: gdprRequired,
    });
    var _c = useForm({
        resolver: yupResolver(schema),
    }), handleSubmit = _c.handleSubmit, control = _c.control, setError = _c.setError;
    var onSubmit = function (data) { return __awaiter(void 0, void 0, void 0, function () {
        var checkUser, formData, createUser, _a, token, user, isSignedIn, error_1;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    setLoading(true);
                    _b.label = 1;
                case 1:
                    _b.trys.push([1, 4, , 5]);
                    return [4 /*yield*/, axiosInstance.post(api.user.check, { email: data.email })];
                case 2:
                    checkUser = _b.sent();
                    formData = serialize(data, { indices: true });
                    return [4 /*yield*/, axiosInstance.post(api.account.createVisitor, formData)];
                case 3:
                    createUser = _b.sent();
                    _a = createUser.data, token = _a.token, user = _a.user;
                    isSignedIn = signIn({
                        token: token,
                        tokenType: 'Bearer',
                        expiresIn: jwtDecode(token).exp,
                        authState: user,
                    });
                    if (isSignedIn) {
                        setLoading(false);
                        navigate(RoutePaths.DASHBOARD_PROFILE, { state: { success: true } });
                    }
                    return [3 /*break*/, 5];
                case 4:
                    error_1 = _b.sent();
                    setLoading(false);
                    if (error_1.response) {
                        error_1.response.data.errors.forEach(function (error) {
                            Object.keys(error).forEach(function (key) {
                                setError(key, { message: error[key] });
                            });
                        });
                    }
                    return [3 /*break*/, 5];
                case 5: return [2 /*return*/];
            }
        });
    }); };
    return (<FadeIn>
      <Seo title="Créer un compte visiteur"/>
      <div className="flex flex-col gap-10 py-10">
        <div>
          <Heading level={1} type="h4">
            S’inscrire sur Majeur·e·s
          </Heading>
          <Paragraph size="lg">Vos informations personnelles</Paragraph>
        </div>
        <form onSubmit={handleSubmit(onSubmit)}>
          <div className="flex flex-col gap-6">
            <FormRow className="justify-center">
              <AvatarInput name="avatar" control={control}/>
            </FormRow>
            <FormRow>
              <TextInput label="Nom" type={Fields.TEXT} name="last_name" placeholder={placeholders.lastName} control={control} required/>
              <TextInput label="Prénom" type={Fields.TEXT} name="first_name" placeholder={placeholders.firstName} control={control} required/>
            </FormRow>
            <FormRow>
              <TextInput label="Email" type={Fields.EMAIL} name="email" placeholder={placeholders.email} control={control} required/>
            </FormRow>
            <FormRow>
              <TextInput label="Mot de passe" type={Fields.PASSWORD} name="password" placeholder={placeholders.password} control={control} required instructions={passwordInstructions}/>
            </FormRow>
            <FormRow>
              <TextInput label="Confirmation du mot de passe" type={Fields.PASSWORD} name="password_confirmation" placeholder={placeholders.password} control={control} required/>
            </FormRow>
            <FormRow>
              <Checkbox ariaLabel="En cochant cette case, j’accepte les conditions générales d’utilisation et la charte de confidentialité du site Majeur·e·s" name="consent_gdpr" control={control} required>
                En cochant cette case, j’accepte les conditions générales d’utilisation et la
                <span className="cursor-pointer font-medium text-brand-01 underline transition-colors hover:text-brand-02" onClick={function () { return (window.location.href = '/politique-de-confidentialite'); }}>
                  charte de confidentialité
                </span>
                du site Majeur·e·s
              </Checkbox>
            </FormRow>
            <Button submit loading={loading}>
              Créer mon compte
            </Button>
          </div>
        </form>
      </div>
    </FadeIn>);
};
export default VisitorData;
